"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toLower = void 0;
const to_string_1 = require("./to-string");
exports.toLower = (value) => to_string_1.toString(value).toLowerCase();
//# sourceMappingURL=to-lower.js.map